module.exports = __webpack_public_path__ + "static/img/ys_ico01.97be65e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ys_ico01.jpg
// module id = ZwIV
// module chunks = 1